var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqIcon10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 61,
    viewBox: "0 0 93 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.25 1H5.25C2.90279 1 1 2.90279 1 5.25V55.25C1 57.5972 2.90279 59.5 5.25 59.5H35.25C37.5972 59.5 39.5 57.5972 39.5 55.25V5.25C39.5 2.90279 37.5972 1 35.25 1Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.25C11 10.1414 15.1414 6 20.25 6C25.3586 6 29.5 10.1414 29.5 15.25C29.5 20.3586 25.3586 24.5 20.25 24.5C15.1414 24.5 11 20.3586 11 15.25Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.25C17 13.4551 18.4551 12 20.25 12C22.0449 12 23.5 13.4551 23.5 15.25C23.5 17.0449 22.0449 18.5 20.25 18.5C18.4551 18.5 17 17.0449 17 15.25Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.25C20 15.3881 20.1119 15.5 20.25 15.5C20.3881 15.5 20.5 15.3881 20.5 15.25C20.5 15.1119 20.3881 15 20.25 15C20.1119 15 20 15.1119 20 15.25Z",
    fill: "white",
    stroke: "#475467"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.25 30H1.25",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 38H11",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 42H11",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 46H11",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.25 54H1.25",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 26,
    r: 14.5,
    fill: "white",
    stroke: "#D0D5DD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2158 25.4286C72.2158 22.1543 74.8701 19.5 78.1444 19.5C81.4187 19.5 84.073 22.1543 84.073 25.4286V30.125H72.2158V25.4286Z",
    fill: "#F8F8F8",
    stroke: "#475467"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 30.4209C71.5 29.558 72.1996 28.8584 73.0625 28.8584H83.2232C84.0862 28.8584 84.7857 29.558 84.7857 30.4209C84.7857 31.2838 84.0862 31.9834 83.2232 31.9834H73.0625C72.1996 31.9834 71.5 31.2838 71.5 30.4209Z",
    fill: "#F8F8F8",
    stroke: "#475467"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon10);
export default __webpack_public_path__ + "static/media/faq-icon10.00dc10264a69011b430a4076f48d2ef6.svg";
export { ForwardRef as ReactComponent };